import { render, staticRenderFns } from "./AddNewMatchSkillDialogCpt.vue?vue&type=template&id=7407610a&"
import script from "./AddNewMatchSkillDialogCpt.vue?vue&type=script&lang=ts&"
export * from "./AddNewMatchSkillDialogCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports